import React, { PropsWithChildren } from "react";

import "./tab-list.css";

export function TabList({ children }: PropsWithChildren) {
	return <div className="tab-list">{children}</div>;
}
